// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#FF6B00",
        secondary: "#03002e",
        // error: "#ff9999",
        error: "#f55b5b",
        success: "#00C853",
        warning: "#fab623",
        backgroundcolor:"#f0f2f5"
      },
      dark: {
        primary: colors.blue.lighten3,
      },
    },
  },
});
